module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_2.3de5960f.jpeg";